module.exports = __webpack_public_path__ + "static/img/fish47.d52a74f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish47.png
// module id = 1H7R
// module chunks = 0